// extracted by mini-css-extract-plugin
module.exports = {"externalLink":"GoogleReCAPTCHATos_externalLink__169wQ"};